import React from 'react';

export type ProgressionBarVariant = 'squared' | 'rounded';

export interface ProgressionBarProps {
    className?: string;
    maxWidth?: string;
    percents: number | { progress: number; total: number };
    label?: boolean;
    labelValue?: string;
    variant?: ProgressionBarVariant;
    animationDuration?: number;
}

export const ProgressionBar: React.FC<ProgressionBarProps> = ({
    className,
    percents,
    maxWidth = '200px',
    label = false,
    labelValue,
    variant = 'rounded',
    animationDuration = 0,
}) => {
    const donePercents = typeof percents === 'number' ? percents : (percents.progress / (percents.total || 1)) * 100;
    const remainingPercents = 100 - donePercents;
    const radius = variant === 'rounded' ? 4 : 0;

    const progressText =
        typeof percents === 'number'
            ? `${Math.round(percents)}%`
            : `${percents.progress}/${percents.total}`;

    return (
        <div
            className={className}
            style={{ maxWidth, display: 'flex', flexDirection: 'column', gap: 4 }}
        >
            {label && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    {labelValue && (
                        <span style={{
                            font: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", sans-serif',
                            fontSize: 10,
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            letterSpacing: '0.08em',
                            color: 'rgba(0,0,0,0.60)',
                            marginRight: 4,
                        }}>
                            {labelValue}
                        </span>
                    )}
                    <span style={{
                        fontSize: 10,
                        fontWeight: 700,
                        textTransform: 'uppercase',
                        letterSpacing: '0.08em',
                        color: 'rgba(0,0,0,0.60)',
                    }}>
                        {progressText}
                    </span>
                </div>
            )}
            <div
                role="progressbar"
                aria-valuenow={donePercents}
                aria-valuemin={0}
                aria-valuemax={100}
                style={{
                    display: 'flex',
                    width: '100%',
                    height: 6,
                    borderRadius: radius,
                    overflow: 'hidden',
                }}
            >
                <span
                    style={{
                        width: `${donePercents}%`,
                        // token-gap: blue/D2 = #1546C1 approx; no direct CSS var available in prototype
                        backgroundColor: '#1546C1',
                        transition: `width ${animationDuration}ms`,
                        display: 'block',
                    }}
                />
                <span
                    style={{
                        width: `${remainingPercents}%`,
                        // token-gap: blue/L5 ≈ rgba(33,150,243,0.20)
                        backgroundColor: 'rgba(33,150,243,0.20)',
                        transition: `width ${animationDuration}ms`,
                        display: 'block',
                    }}
                />
            </div>
        </div>
    );
};
